module.exports = __webpack_public_path__ + "img/sol_cap1.4fe3db32.png";